import { TbCurrencyDollar } from 'react-icons/tb';
import { FeatureFlags } from '@oliasoft/feature-flags';
import { FeatureFlagName } from 'src/enums/feature-flags';
import { CurrencyTabContent } from './currency-tab';

export const getCurrencyTab = () => {
  const isProjectCurrencySettingsActive = FeatureFlags.isActive(FeatureFlagName.UserSetCurrency);
  return isProjectCurrencySettingsActive
    ? {
        icon: <TbCurrencyDollar />,
        content: <CurrencyTabContent />,
      }
    : null;
};
